import "./SportStatTypeGroups.css";

export default function SportStatTypeGroups() {
  return <div>SportStatTypeGroups</div>;
}
